export const isDevelopment = process.env.NODE_ENV === 'development';

// Utility function used to add a delay (for example, in async functions), to help with testing or simulating network latency.
export const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
